<template>
  <div style="max-height: 1920px;">

    <v-row>
      <v-col cols="12" md="12" style="text-align: center;">
        <v-row>
          <v-col cols="12" md="12" style="text-align: center;">
            <v-img alt="Logo" class="shrink mr-2 app" contain :src="logoimage" transition="scale-transition"
              width="1000" />
          </v-col>
        </v-row>
        <v-sheet class="folded-corner" width="1045" height="1100" style="margin-top: 250px">
          <v-container>
            <v-row>
              <v-card elevation="0" width="866" height="1100" style="
                  background-color: white;
                " class="align-center pa-4 mx-auto">
                <!-- <v-row style="margin-top: 3%">
                  <v-col cols="12" md="12" style="
                      text-align: center;
                      font-size: 60px;
                      color: #344054;
                      font-weight: bold;
                    ">
                    {{ $t("message.QRCodeVisitors") }}
                  </v-col>
                </v-row> -->
                <v-row>
                  <v-col cols="12" md="12" style="text-align: center;">
                    <span style="color: #344054;font-size: 60px;font-weight: 800;">
                      {{ "คิวอาร์โค้ดสำหรับผู้มาติดต่อ" }}
                    </span>
                    <br>
                    <span style="color: #898A8C;font-size: 40px;font-weight: 700;">{{ "QR Code Visitors" }}</span>
                  </v-col>
                </v-row>
                <v-row style="display: flex;justify-content: center;">
                  <v-col cols="7" md="7">

                    <v-divider style="border-top-width: 8px !important;border-color: #344054; "></v-divider>
                  </v-col>
                </v-row>
                <v-row style="display: flex;justify-content: center;">
                  <v-col cols="12" md="12">
                    <span style="color: #344054;font-size: 20px;font-weight: 800;">
                      {{ "*Please take a photo of the Qrcode" }}
                    </span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 3%">
                  <v-col cols="12" md="12" style="    display: flex;
    justify-content: center;
">
                    <v-card v-if="show" id="capture" elevation="0" style="
                            background-color: rgb(255, 255, 255) !important;height: 600px;page-break-after: always;width: 650px;padding: 0;
                          ">
                      <!-- <v-col cols="12" md="12" sm="12" lg="12"
                        style="background-color: #fff;text-align: -webkit-center;">
                        <v-img cover height="150" width="500" src="@/assets/logo-01.png"></v-img>
                      </v-col> -->
                      <v-col cols="12" md="12" sm="12" lg="12" style="
                              text-align: center;
                              padding: 0;
                              background-color: #fff;
                            ">
                        <label style="font-size: 35px;">{{ tenantName }}</label>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" lg="12" style="
                              text-align: center;
                              padding: 0;
                              background-color: #fff;
                            ">
                        <label style="background-color: #fff;font-size: 30px;">{{ $t("message.Floor") }} : {{ floorName
                        }} </label>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" lg="12" style="
                              text-align: center;
                              padding: 0;
                              display: grid;
                              justify-content: space-evenly;
                              background-color: #fff;
                            ">
                        <qr-code style="margin: 15px;" :size="350" :text="Qrcode" error-level="L"></qr-code>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" lg="12" style="
                              text-align: center;
                              padding: 0;
                              background-color: #fff;
                            ">
                        <label style="font-size: 30px;">{{ $t("message.IssueDate") }} : {{ ChangeFormatDate(startDate)
                        }}</label>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" lg="12" style="
                              text-align: center;
                              padding: 0;
                              background-color: #fff;
                            ">
                        <label style="font-size: 30px;">{{ $t("message.ExpiryDate") }} : {{ ChangeFormatDate(endDate)
                        }}</label>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" lg="12" style="
                              text-align: center;
                              background-color: #fff;
                              font-size: 18px;
                            ">
                        <label>{{ $t("message.Onetime") }}</label>
                      </v-col>
                    </v-card>

                    <v-card v-if="!show" elevation="0" style="
                            background-color: rgb(255, 255, 255) !important;height: 500px;page-break-after: always;width: 500px;padding: 0;font-size: 50px;
                      color: red;
                      font-weight: bold;
                          ">
                      {{ "*" + message }}
                    </v-card>
                  </v-col>
                </v-row>
                <!-- <v-row style="margin-top: 5%">
                  <v-col cols="12" md="12" style="text-align: center">
                    <v-btn v-if="show" color="#344054" class="box white--text mt-2 text-capitalize" router
                      id="downloadPhoto" :download="PictureName" width="400"
                      style="font-size: 45px; " height="100" @click="print()">
                      {{ $t("message.PrintQRCode") }}</v-btn>
                  </v-col>
                </v-row> -->
                <v-row>
                  <v-col cols="12" md="12" style="text-align: center">
                    <v-btn color="#344054" class="box white--text mt-2 text-capitalize" router width="400"
                      style="font-size: 45px; " height="100" @click="BacktoNationalIDCard()">{{
                        $t("message.Back") }}</v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-row>

          </v-container>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import html2canvas from "html2canvas";
// import logoimage from "@/assets/OneBangkokLogo.png";
// import ChangeLanguage from "@/components/ChangeLanguage";
export default {
  name: "CapturePerson",
  components: {
    // ChangeLanguage,
  },
  data() {
    return {
      url: enurl.apiUrl,
      settingUrl: enurl.settingUrl,
      DefaultLogo: "@/assets/logo192.png",
      DefaultBG: "@/assets/1D2939.png",
      Datetime: "",
      ResponsePassport: [],
      ResponseSmartCard: [],
      isPhotoTaken: false,
      download: false,
      PictureName: "PersonID.jpg",
      startDate: "",
      endDate: "",
      Qrcode: "https://www.onebangkok.com/th/",
      tenantName: "One Bangkok",
      floorName: "1",
      zoneName: "",
      data: [],
      show: true,
      message: "",
      logoimage: "",
      timerCount: 30,
    };
  },


  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
            if (this.timerCount == 0) {
              this.BackToMain();
            }
          }, 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },

  mounted: function () {
    let self = this;
    self.logoimage = require("@/assets/OneBangkokLogo.png");
    // self.createCameraElement();
    var s = new Date();
    self.startDate = s;
    self.endDate = s;
    // console.log(self.$route.params.data);
    self.data = self.$route.params.data;
    self.floorName = self.data.floorID;
    self.zoneName = self.$route.params.zoneName;
    self.tenantName = self.$route.params.tenantName;
    self.addDataVisitor();
 
  },

  methods: {
    addDataVisitor() {
      let self = this;
      // self.LoadingDialog = true;


      let temp = self.data;


      axios
        .post(`${self.url}VMS/addDataVisitor`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            console.log(response.data.data);
            let temp = localStorage.getItem("LogId");
            if (temp != "") {
              self.show = false;
              self.message = "Successfully";
              setTimeout(() => {
                self.GotoMainPage();
              }, 3000);
            } else {
              var s = new Date();
              self.startDate = s;
              let dateOut = response.data.data.split('"')[7].replace("Z", "");

              self.endDate = dateOut;
              self.Qrcode = response.data.data;
              self.show = true;
            }
          }
          if (response.data.status == 1) {
            self.show = false;
            self.message = response.data.message;
            setTimeout(() => {
              self.GotoMainPage();
            }, 3000);
          }
        })
        .catch(function () { });
    },
    print() {
      let self = this;
      html2canvas(document.querySelector("#capture")).then((canvas) => {
        const base64 = canvas.toDataURL("image/png");

        var tWindow = window.open("");

        tWindow.document.body.appendChild(canvas);

        tWindow.focus();

        tWindow.print();

        tWindow.close();

        self.base64 = base64;

        self.GotoMainPage();

        // self.ReSet();
      });
    },
    ReSet() {
      let self = this;
      self.$router.push("/CapturePerson");
    },
    getCurrentDate() {
      let self = this;
      let newDate = new Date();
      let date =
        newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
      let month = newDate.getMonth() + 1;
      let year =
        newDate.getFullYear() < 2500
          ? newDate.getFullYear() + 543
          : newDate.getFullYear();
      let hours =
        newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
      let minutes =
        newDate.getMinutes() < 10
          ? "0" + newDate.getMinutes()
          : newDate.getMinutes();
      let seconds =
        newDate.getSeconds() < 10
          ? "0" + newDate.getSeconds()
          : newDate.getSeconds();
      self.Datetime = `${date}/${month < 10 ? `0${month}` : `${month}`
        }/${year}  ${hours}:${minutes}:${seconds}`;
    },

    ChangeFormatDate(date) {
      if (!date) return null;

      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      // var ampm = hours >= 12 ? "PM" : "AM";
      // hours = hours % 12;
      // hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var month = DateData.getMonth() + 1;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        month +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },

    GotoMainPage() {
      let self = this;
      // location.reload();
      // localStorage.setItem("refresh", '');
      self.$router.push("/MainMenu");
    },

    BacktoNationalIDCard() {
      let self = this;

      // self.$router.push("/NationalIDCard");
      self.$router.push("/MainMenu");
      // self.$router.push("/FindingTenant");
    },

    CapturePerson() {
      let self = this;
      self.$router.push("/CapturePerson");
    },
  },
};
</script>
<style scoped>
@media all and (orientation: portrait) {
  .fullscreen {
    height: 1890px;
  }
}

@media all and (orientation: landscape) {
  .fullscreen {
    height: auto;
  }
}
</style>
